"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const Badge_1 = require("../Badge");
const Div_1 = require("../Div");
const Flex_1 = require("../Flex");
const Icon_1 = require("../Icon");
const Text_1 = require("../Text");
const Nav = styled_1.default.nav({
    margin: 0,
    padding: 0,
    display: 'flex',
    width: '100%',
    minHeight: 42,
    borderBottom: constants_1.theme.border.style.thinLight,
    background: constants_1.Color.WHITE,
});
const Inner = styled_1.default.div(({ center }) => ({
    display: 'flex',
    flexShrink: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    boxSizing: 'border-box',
    margin: 0,
    paddingLeft: constants_1.theme.spacing[2.5],
    paddingRight: constants_1.theme.spacing[2.5],
    ...(center && {
        width: 1088,
        margin: '0 auto',
    }),
}));
const Tabs = (0, styled_1.default)(Flex_1.Flex)({
    flex: 1,
    gap: constants_1.theme.spacing[1],
});
const Tab = styled_1.default.li(({ isLocked }) => ({
    margin: 0,
    listStyle: 'none',
    fontSize: 14,
    textAlign: 'center',
    display: 'center',
    color: isLocked ? constants_1.Color.DARK_MEDIUM_GREY : constants_1.Color.CHARCOAL,
    cursor: isLocked ? 'not-allowed' : 'pointer',
    height: 'fit-content',
}));
const Hover = styled_1.default.div((props) => ({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: '4px 8px',
    borderRadius: 8,
    height: 'fit-content',
    color: constants_1.Color.DARK_GREY,
    ':hover': props.isLocked
        ? undefined
        : {
            background: constants_1.Color.LIGHT_GREY,
        },
    ...(props.isActive && {
        background: constants_1.Color.LIGHT_GREY,
        color: constants_1.Color.CHARCOAL,
        ':after': {
            display: 'block',
            content: '""',
            width: '100%',
            height: 2,
            background: constants_1.Color.BLUE,
            position: 'absolute',
            borderRadius: 1,
            bottom: -8,
            left: 0,
        },
    }),
}));
const Navigation = ({ onChange, tabs, value, title, center, children, }) => {
    return ((0, jsx_runtime_1.jsx)(Nav, { children: (0, jsx_runtime_1.jsxs)(Inner, { center: center, children: [title && ((0, jsx_runtime_1.jsx)(Badge_1.Badge, { styles: { mr: 3 }, color: "white", squared: true, children: (0, jsx_runtime_1.jsx)(Text_1.Text, { children: title }) })), (0, jsx_runtime_1.jsx)(Tabs, { as: "ul", children: tabs
                        ?.filter(({ hidden }) => !hidden)
                        .map((option) => ((0, jsx_runtime_1.jsx)(Tab, { onClick: () => !option.isLocked && onChange?.(option.value), isLocked: option.isLocked, children: (0, jsx_runtime_1.jsxs)(Hover, { isActive: option.match
                                ? typeof value === 'string' && option.match.test(value)
                                : option.value === value, isLocked: option.isLocked, children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: option.icon, mr: 2, size: "sm" }), (0, jsx_runtime_1.jsx)(Text_1.Text, { noSelect: true, noWrap: true, fontWeight: 600, children: option.label }), option.badge && !option.isLocked && ((0, jsx_runtime_1.jsx)(Div_1.Div, { styles: {
                                        borderRadius: constants_1.theme.border.radius.normal,
                                        fontWeight: constants_1.theme.font.weight.medium,
                                        fontSize: 11,
                                        color: option.badge.inFocus
                                            ? constants_1.Color.WHITE
                                            : constants_1.Color.DARKER_GREY,
                                        background: option.badge.inFocus
                                            ? constants_1.Color.BLUE
                                            : constants_1.Color.GREY,
                                        ml: 2,
                                        px: 2,
                                        py: 0.5,
                                    }, children: option.badge.count }))] }) }, option.label))) }), children] }) }));
};
exports.Navigation = Navigation;
